import { forwardRef } from 'react';

import { Close, Content, DialogContentProps } from '@radix-ui/react-dialog';
import { RemoveScroll } from 'react-remove-scroll';

import CloseIcon from '~/icons/close.svg';
import { IImageMedia, IM70MediaItem } from '~/lib/data-contract';
import { Icon } from '~/shared/components/Icon/Icon';

import styles from './galleryDialog.module.css';

import { Gallery } from '../Gallery/Gallery';

export type GalleryDialogContentProps = {
	mediaItems: IImageMedia[] | IM70MediaItem[];
	dialogProps?: DialogContentProps;
	initialSlide: number;
};

export const GalleryDialogContent = forwardRef<HTMLDivElement, Omit<GalleryDialogContentProps, 'asChild'>>(({ children, mediaItems, initialSlide = 0, dialogProps = {} }, forwardedRef) => {
	const handleOnOpenAutoFocus = (event: Event) => {
		if (dialogProps.onOpenAutoFocus) {
			dialogProps.onOpenAutoFocus(event);
		} else {
			event.preventDefault();
		}
	};

	return (
		<Content
			className={styles.content}
			{...dialogProps}
			onOpenAutoFocus={handleOnOpenAutoFocus}
			ref={forwardedRef}
		>
			<RemoveScroll>
				<div className={styles.pane}>
					{children}
					<Close asChild>
						<button className={styles.closeButton}>
							<Icon size="lg">
								<CloseIcon />
							</Icon>
						</button>
					</Close>

					<Gallery
						mediaItems={mediaItems}
						initialSlide={initialSlide}
					/>
				</div>
			</RemoveScroll>
		</Content>
	);
});
